import React from 'react';
import { useTranslation } from 'react-i18next';
import useAppContext from '../../../../context/useAppContext';
import { Dropdown } from '@weezevent/nacre';
import { useHistory } from 'react-router-dom';
import RateModel from '../../../../models/rateModel';
import PropTypes from 'prop-types';

export function ModifyAction({ objects: selectedRates, onClick = () => {} }) {
    const { t } = useTranslation();
    const [{ event, organization }] = useAppContext();
    const history = useHistory();

    if (selectedRates.length !== 1) {
        return null;
    }

    return (
        <Dropdown.Item
            onClick={() => {
                onClick();
                if (selectedRates[0] instanceof RateModel) {
                    return history.push(`/ticket/O${organization.pk}/E${event.id}/settings/rates/${selectedRates[0].pk}`);
                }
                return history.push(`/ticket/O${organization.pk}/rates/${selectedRates[0].pk}`);
            }}
        >
            {t('ticket.rates.modifyRate')}
        </Dropdown.Item>
    );
}

ModifyAction.propTypes = {
    objects: PropTypes.array //required
};
